import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'unit',
  data: function data() {
    return {
      searchForm: {
        gradeId: ''
      },
      gradeList: [],
      tableData: [],
      loading: false
    };
  },
  mounted: function mounted() {
    this.loadGrade();
  },
  methods: {
    loadGrade: function loadGrade() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$api.loadGradeList();

              case 3:
                res = _context.sent;
                _this.gradeList = res;
                console.log(res);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    handleSearchFormSubmit: function handleSearchFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (_this2.searchForm.gradeId) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _this2.loading = true;
                params = new URLSearchParams();
                params.set('gradeId', _this2.searchForm.gradeId);
                _context2.next = 8;
                return _this2.$api.loadUnitList(params.toString());

              case 8:
                res = _context2.sent;
                res.forEach(function (e) {
                  e.isEdit = false;
                });
                _this2.tableData = res;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 16:
                _context2.prev = 16;
                _this2.loading = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13, 16, 19]]);
      }))();
    },
    edit: function edit(row) {
      row.isEdit = true;
    },
    cancel: function cancel(row) {
      row.isEdit = false;
    },
    save: function save(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                params = {
                  gradeId: row.gradeId,
                  unit: row.unit,
                  orderIndex: row.orderIndex
                };

                if (row.id) {
                  params.id = row.id;
                }

                _context3.next = 5;
                return _this3.$api.saveUnit(params);

              case 5:
                res = _context3.sent;
                res.forEach(function (e) {
                  e.isEdit = false;
                });
                _this3.tableData = res;

                _this3.$message({
                  message: '保存成功',
                  type: 'success'
                });

                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

                _this3.$message({
                  message: '保存失败',
                  type: 'warning'
                });

                console.log(_context3.t0);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 11]]);
      }))();
    },
    add: function add() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var gradeId, garde;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                gradeId = _this4.tableData.length === 0 ? _this4.searchForm.gradeId : _this4.tableData[0].gradeId;

                if (gradeId) {
                  _context4.next = 4;
                  break;
                }

                _this4.$message({
                  message: '请选择年级',
                  type: 'warning'
                });

                return _context4.abrupt("return");

              case 4:
                console.log(gradeId);
                garde = _this4.gradeList.find(function (e) {
                  return e.id === gradeId;
                }).grade;
                console.log(garde);

                _this4.tableData.push({
                  gradeId: gradeId,
                  grade: garde,
                  orderIndex: 0,
                  isEdit: true
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};